import { render, staticRenderFns } from "./PartnerApi.vue?vue&type=template&id=0594cdf0&scoped=true&"
import script from "./PartnerApi.vue?vue&type=script&lang=js&"
export * from "./PartnerApi.vue?vue&type=script&lang=js&"
import style0 from "./PartnerApi.vue?vue&type=style&index=0&id=0594cdf0&lang=scss&scoped=true&"
import style1 from "./PartnerApi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0594cdf0",
  null
  
)

export default component.exports